/*!

=========================================================
* Black Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
//import configureStore from './store/configureStore';  //wire up redux store to the entry point for application
//import {Provider} from 'react-redux';  //Companion lib, higher order component..for wrapping.
import { UserLoginProvider } from "./context/UserLoginContext";
import { RegistrationProvider } from "./context/RegistrationContext";
import { QuestionsProvider } from "./context/QuestionsContext";
import { AthletesProvider } from "./context/AthletesContext";
import { CollectionsProvider } from "./context/CollectionsContext";
import { EventsProvider } from "./context/EventsContext";

import AuthLayout from "layouts/Auth/Auth.js";
import AdminLayout from "layouts/Admin/Admin.js";
import RTLLayout from "layouts/RTL/RTL.js";

import "assets/css/nucleo-icons.css";
import "react-notification-alert/dist/animate.css";
import "assets/scss/black-dashboard-pro-react.scss?v=1.2.0";
import "assets/demo/demo.css";

//const store = configureStore();

// Log environment configuration on startup
console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
console.log('🚀 TheDeep Dashboard Starting...');
console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
console.log('📋 Environment Configuration:');
console.log('   NODE_ENV:', process.env.NODE_ENV);
console.log('   REACT_APP_USE_PRODUCTION_API:', process.env.REACT_APP_USE_PRODUCTION_API);
console.log('   Local API URL:', process.env.REACT_APP_LOCAL_API_URL);
console.log('   Production API URL:', process.env.REACT_APP_PRODUCTION_API_URL);
console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');

ReactDOM.render(
    <UserLoginProvider>
        <QuestionsProvider>
            <AthletesProvider>
                <RegistrationProvider>
                    <CollectionsProvider>
                        <EventsProvider>
                          <BrowserRouter>
                            <Switch>
                              <Route path="/auth" render={(props) => <AuthLayout {...props} />} />
                              <Route path="/admin" render={(props) => <AdminLayout {...props} />} />
                              <Route path="/rtl" render={(props) => <RTLLayout {...props} />} />
                              <Redirect from="/" to="/admin/dashboard" />
                            </Switch>
                          </BrowserRouter>
                        </EventsProvider>
                    </CollectionsProvider>
                </RegistrationProvider>
            </AthletesProvider>
        </QuestionsProvider>
    </UserLoginProvider>,
  document.getElementById("root")

);
